import React from 'react'
import Translation from '../Translation/cont/Translation'

function formatDate(dateStr) {
    const parts = dateStr.split('T')[0].split('-')
    return `${parts[2]}.${parts[1]}.`
}

function formatWeekday(dateStr) {
    const [year, month, day] = dateStr.split('T')[0].split('-').map(Number)
    return new Date(year, month - 1, day).toLocaleDateString('de-DE', { weekday: 'short' })
}

class DashboardFutureMoviesPanel extends React.Component {
    render() {
        const { isOpen, nextWeekMovies, laterMovies, onClose } = this.props

        const laterGroups = laterMovies.reduce((acc, movie) => {
            const key = movie.displayDateStart ? movie.displayDateStart.split('T')[0] : ''
            if (!acc[key]) acc[key] = []
            acc[key].push(movie)
            return acc
        }, {})

        const renderMovie = (movie) => (
            <div key={movie.id} className={`db-fm-item${movie.isPremiere ? ' db-fm-item--premiere' : ''}`}>
                <div className="db-fm-date text-small-light">{formatDate(movie.displayDateStart)}</div>
                <div className="db-fm-film text-regular">{movie.title}</div>
                <div className="db-movie-badges">
                    {movie.isPremiere && <span className="db-movie-badge db-movie-badge--premiere text-small-light"><Translation id="dashboard_panel_badge_premiere">Premiere</Translation></span>}
                    {movie.isOV      && <span className="db-movie-badge db-movie-badge--ov text-small-light"><Translation id="dashboard_panel_badge_ov">OV</Translation></span>}
                </div>
            </div>
        )

        return (
            <div className={`db-expand-panel db-expand-panel--future${isOpen ? ' db-expand-panel--open' : ''}`}>
                <div className="db-panel-head">
                    <span className="db-panel-title text-small-light"><Translation id="dashboard_stat_future_movies_label">Future Movies</Translation></span>
                    <span className="db-panel-count text-small-light"><Translation id="dashboard_panel_movies_count" before={`${nextWeekMovies.length + laterMovies.length} `}>movies</Translation></span>
                    <span className="db-panel-close text-small-light" onClick={onClose}>✕ <Translation id="button_close">Close</Translation></span>
                </div>

                <div className="db-panel-body">
                    {nextWeekMovies.length > 0 && (
                        <React.Fragment>
                            <div className="db-fm-divider">
                                <span className="db-fm-divider-lbl db-fm-divider-lbl--next text-small-light">
                                    <Translation id="dashboard_panel_next_week" after={` — ${formatWeekday(nextWeekMovies[0].displayDateStart)}, ${formatDate(nextWeekMovies[0].displayDateStart)}`}>Next week</Translation>
                                </span>
                                <div className="db-fm-divider-line" />
                            </div>
                            {nextWeekMovies.map(renderMovie)}
                        </React.Fragment>
                    )}

                    {Object.keys(laterGroups).sort().map(dateKey => (
                        <React.Fragment key={dateKey}>
                            <div className="db-fm-divider">
                                <span className="db-fm-divider-lbl text-small-light"><Translation id="dashboard_panel_from_date" after={` ${formatDate(dateKey)}`}>From</Translation></span>
                                <div className="db-fm-divider-line" />
                            </div>
                            {laterGroups[dateKey].map(renderMovie)}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        )
    }
}

export default DashboardFutureMoviesPanel
